export default __webpack_public_path__ + "static/media/RedCard.20b9a9c1.svg";